import { defineMessages } from 'react-intl';
import { GENERAL_SECTION_ITEMS_LABELS } from '../data/generalSectionItems';

export const GENERAL_SECTION_ITEMS_MESSAGES = defineMessages({
  [GENERAL_SECTION_ITEMS_LABELS.Status]: {
    id: 'Status',
    defaultMessage: 'Status',
    description: `Text for footer link item - Status`,
  },
  [GENERAL_SECTION_ITEMS_LABELS.Terms]: {
    id: 'Terms',
    defaultMessage: 'Terms',
    description: `Text for footer link item - Terms`,
  },
  [GENERAL_SECTION_ITEMS_LABELS.Privacy]: {
    id: 'Privacy',
    defaultMessage: 'Privacy',
    description: `Text for footer link item - Privacy`,
  },
  [GENERAL_SECTION_ITEMS_LABELS.Accessibility]: {
    id: 'Accessibility',
    defaultMessage: 'Accessibility',
    description: `Text for footer link item - Accessibility`,
  },
  [GENERAL_SECTION_ITEMS_LABELS.Cookies]: {
    id: 'Cookies',
    defaultMessage: 'Cookies',
    description: `Text for footer link item - Cookies`,
  },
  [GENERAL_SECTION_ITEMS_LABELS['Manage Cookie Preferences']]: {
    id: 'Manage Cookie Preferences',
    defaultMessage: 'Manage Cookie Preferences',
    description: `Text for footer link item - Manage Cookie Preferences`,
  },
  [GENERAL_SECTION_ITEMS_LABELS['Do Not Sell or Share My Personal Information']]: {
    id: 'Do Not Sell or Share My Personal Information',
    defaultMessage: 'Do Not Sell or Share My Personal Information',
    description: `Text for footer link item - Do Not Sell or Share My Personal Information`,
  },
});
